import api from '../lib/api';

export const FEATURE_FLAGS_LOADING = 'FEATURE_FLAGS_LOADING';
export const FETCH_MARKET_FEATURE_FLAGS = 'FETCH_MARKET_FEATURE_FLAGS';
export const UPDATE_FEATURE_FLAGS = 'UPDATE_FEATURE_FLAGS';

function fetchFeatureFlags(marketId) {
  return (dispatch) => {
    dispatch({ type: FEATURE_FLAGS_LOADING, payload: true });
    api.getFeatureFlags(marketId)
      .then((data) => {
        dispatch({ type: FETCH_MARKET_FEATURE_FLAGS, payload: data.data });
        dispatch({ type: FEATURE_FLAGS_LOADING, payload: false });
        return data;
      });
  };
}

function bulkUpdateFlagStatus(args) {
  return (dispatch) => api.bulkUpdateFlagStatus(args)
    .then((data) => {
      dispatch({ type: UPDATE_FEATURE_FLAGS, payload: data });
      return data;
    });
}

export default {
  fetchFeatureFlags,
  bulkUpdateFlagStatus,
};
